export default __webpack_public_path__ + "static/media/ATTAleckSans_Rg.45ef6908.ttf";